import { CircularProgress, Typography } from '@mui/material'
import { ReactNode, useEffect, useState } from 'react'
import useLogout from '../../hooks/useLogout'
import { initApi, loginParseLegacy } from '../../api/auth'
import RouterOutsideContainer from '../../routers/RouterOutsideContainer'

type ParseGuardProps = {
    children: ReactNode
    token: string | null
}

export const ParseGuardExternal = ({ children, token }: ParseGuardProps) => {
    const { loading: isLoadingLogout, logout } = useLogout()
    const [isLoadingInit, setIsLoadingInit] = useState<boolean>(true)

    useEffect(() => {
        const initParse = async () => {
            if (!token) return
            setIsLoadingInit(true)
            await initApi()
            try {
                await loginParseLegacy(token)
                localStorage.setItem('sessionToken', token)
            } catch (error) {
                logout()
            }
            setIsLoadingInit(false)
        }

        initParse()
    }, [logout, token])

    if (isLoadingInit || isLoadingLogout)
        return (
            <RouterOutsideContainer>
                <CircularProgress size="3.6rem" />
                <Typography fontWeight={600} fontSize="1.6rem">
                    Chargement de l'espace TokTokDoc
                </Typography>
            </RouterOutsideContainer>
        )

    return children
}
